import React, { useCallback, useEffect, useState } from 'react';

export const useManageDialogSection = () => {
    const [showDialogWindow, setDialogWindowState] = useState<boolean>(false);
    const [isTooltipOpened, setIsTooltipOpened] = useState(false);
    const [clickTarget, setClickTarget] = useState<EventTarget | null>(null);

    const onDialogClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
        setClickTarget(e.target);
        setIsTooltipOpened(!isTooltipOpened);
    }, [isTooltipOpened]);

    const handleClickAllExceptDialog = useCallback((e: MouseEvent): void => {
        if (clickTarget && clickTarget === e.target && isTooltipOpened) {
            setDialogWindowState(true);
        } else {
            setDialogWindowState(false);
            setIsTooltipOpened(false);
        }
    }, [clickTarget, isTooltipOpened]);

    useEffect(() => {
        document.addEventListener('click', handleClickAllExceptDialog);

        return () => {
            document.removeEventListener('click', handleClickAllExceptDialog);
        };
    }, [isTooltipOpened, handleClickAllExceptDialog]);

    return {
        onDialogClick, showDialogWindow
    };
};
